var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduct1Q4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.721313C13.3404 0.721313 10.3929 1.08483 7.86625 1.55224C7.90582 5.18231 5.27658 8.30906 1.67578 8.89474C1.67578 15.8942 4.5453 29.2436 16.5 32.4323C28.4547 29.2436 31.3242 15.8942 31.3242 8.89481C27.7234 8.30912 25.0942 5.18237 25.1338 1.55224C22.6071 1.08483 19.6596 0.721313 16.5 0.721313Z",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8926 26.2623C23.4875 24.7832 24.7703 22.9437 25.7803 20.8382C27.1896 17.9 28.0727 14.3724 28.3389 11.0083C25.4373 9.72129 23.2789 7.14813 22.525 4.06347C20.5295 3.78019 18.5153 3.6217 16.5002 3.6217C14.4852 3.6217 12.471 3.78019 10.4755 4.06347C9.72158 7.14819 7.56317 9.72135 4.66162 11.0083C4.92775 14.3723 5.81088 17.9 7.22022 20.8382C8.23052 22.9444 9.51378 24.7844 11.1094 26.2637",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1255 29.8854V11.2284C11.1255 10.4894 11.7302 9.88474 12.4692 9.88474C13.2082 9.88474 13.8129 10.4894 13.8129 11.2284M16.5002 10.5565C16.5002 9.81751 15.8956 9.21294 15.1566 9.21294C14.4176 9.21294 13.8129 9.81758 13.8129 10.5566V14.1463M16.5002 14.1462V10.2207C16.5002 9.48165 17.1049 8.87708 17.8439 8.87708C18.5829 8.87708 19.1875 9.48165 19.1875 10.2207V13.4745M19.1875 16.1618C18.4485 16.1618 17.8439 15.5571 17.8439 14.818C17.8439 14.079 18.4486 13.4745 19.1875 13.4745L21.707 13.4744C22.7399 13.4744 23.2892 14.457 23.0151 15.3938L21.8749 19.2904V29.8854M19.1875 10.5565C19.1875 9.81751 19.7922 9.21288 20.5313 9.21288C21.2703 9.21288 21.8749 9.81783 21.8749 10.5565V13.2979",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.539 21.3059H11.4614",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.539 26.0089H11.4614",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1495 23.6573H14.1484",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1255 14.1697C11.1382 14.9025 11.736 15.4899 12.4689 15.4899C13.2111 15.4899 13.8126 14.8883 13.8126 14.1462C13.8126 14.8883 14.4142 15.4899 15.1563 15.4899C15.8983 15.4899 16.4999 14.8883 16.4999 14.1462C16.4999 14.8883 17.1015 15.4899 17.8436 15.4899C17.8853 15.4899 17.927 15.488 17.9685 15.4841",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct1Q4);
export default __webpack_public_path__ + "static/media/product-1-q-4.0a948ff7e9745c47fdcf8ef2886c5499.svg";
export { ForwardRef as ReactComponent };